
import React from "react";
import { Link } from "react-router-dom";
import { Card } from "../ui/card";

interface Activity {
  animalId: string;
  animalName: string;
  event: string;
  date: string;
}

interface RecentActivityProps {
  activities: Activity[];
}

const RecentActivity: React.FC<RecentActivityProps> = ({ activities }) => {
  console.log("RecentActivity props:", activities); // Debugging line

  return (
    <section>
      <h2 className="mb-4 text-lg font-semibold">Recent Activity</h2>
      <div className="space-y-3">
        {activities && activities.length > 0 ? (
          activities.map((activity, index) => (
            <Link
              key={index}
              to={`/animals/${activity.animalId}`}
              className="block"
            >
              <Card>
                <div className="p-3 hover:text-[hsl(215_95%_32%)]">
                  <p className="font-medium">{activity.animalName}</p>
                  <p className="text-sm text-muted-foreground hover:text-[hsl(215_95%_32%)]">
                    {activity.event}
                  </p>
                  <p className="text-xs text-muted-foreground hover:text-[hsl(215_95%_32%)]">
                    {activity.date}
                  </p>
                </div>
              </Card>
            </Link>
          ))
        ) : (
          <Card>
            <div className="p-3">
              <p className="text-center text-muted-foreground">
                No recent activity
              </p>
            </div>
          </Card>
        )}
      </div>
    </section>
  );
};

export default RecentActivity;

